// extracted by mini-css-extract-plugin
export default {"payButton":"PaymentFooter_payButton__LqAN1"};